import React, { useEffect, useState } from 'react'
import { Button, Card, Radio, Space, Spin, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { fetchDeliveryLocations } from '../api/deliveryLocations'
import { apiUrl } from '../config/api'

export default function DeliveryLocation() {
    const navigate = useNavigate()
    const [value, setValue] = useState(null)


    const { data, isLoading, isError, error, refetch } = useQuery({
        queryKey: ['deliveryLocations'],
        queryFn: fetchDeliveryLocations,
    })

    // Preselect the first option when data arrives and nothing selected yet
    useEffect(() => {
        if (!value && Array.isArray(data) && data.length > 0) {
            setValue(data[0].id)
        }
    }, [data, value])

    const handleSave = async () => {
        if (!value) return
        const selected = Array.isArray(data) ? data.find((loc) => loc.id === value) : null
        if (selected) {
            // Read previous deliveryLocation id, if any
            let prevId = null
            try {
                const prevRaw = localStorage.getItem('deliveryLocation')
                if (prevRaw) {
                    const prevObj = JSON.parse(prevRaw)
                    prevId = prevObj?.id ?? null
                }
            } catch { /* ignore */ }

            // Persist the new selection
            localStorage.setItem('deliveryLocation', JSON.stringify(selected))

            // If changed, clear persisted cart so orders don't mix across locations
            if (prevId !== selected.id) {
                try { localStorage.removeItem('om_cart') } catch { /* ignore */ }
            }

            // If signed in, inform backend about deliveryLocation change
            try {
                const accessToken = localStorage.getItem('accessToken')
                if (accessToken) {
                    await fetch(apiUrl('/api/users/me'), {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ deliveryLocationId: selected.id })
                    }).then(async (r) => {
                        if (r && r.ok) {
                            const json = await r.json().catch(() => null)
                            if (json) {
                                try { localStorage.setItem('user', JSON.stringify(json)) } catch { /* ignore */ }
                            }
                        }
                    }).catch(() => null)
                }
            } catch { /* ignore */ }
        }
        // Navigate to categories; MainLayout will detect any change and handle in-memory cart
        navigate('/categories')
    }

    return (
        <div style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', padding: 'clamp(12px, 4vw, 24px)' }}>

            <Card style={{ width: 'min(100%, 560px)' }}>
                <img style={{ width: '100%' }} src="/delivery-location.jpg" />
                <Space direction="vertical" size={20} style={{ width: '100%' }}>
                    <Typography.Title level={3} style={{ margin: 0, textAlign: 'center' }}>
                        موقع التسليم
                    </Typography.Title>
                    <Typography.Paragraph style={{ marginBottom: 0, textAlign: 'center' }}>
                        يرجى اختيار موقع التسليم الخاص بك للمتابعة.
                    </Typography.Paragraph>

                    {isLoading && (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
                            <Spin />
                        </div>
                    )}

                    {isError && (
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <Typography.Paragraph type="danger" style={{ margin: 0 }}>
                                حدث خطأ أثناء جلب مواقع التسليم: {error?.message || 'خطأ غير معروف'}
                            </Typography.Paragraph>
                            <Button onClick={() => refetch()}>إعادة المحاولة</Button>
                        </Space>
                    )}

                    {!isLoading && !isError && Array.isArray(data) && data.length === 0 && (
                        <Typography.Paragraph style={{ margin: 0 }}>
                            لا توجد مواقع تسليم متاحة حالياً.
                        </Typography.Paragraph>
                    )}

                    {!isLoading && !isError && Array.isArray(data) && data.length > 0 && (
                        <Radio.Group
                            style={{ width: '100%' }}
                            onChange={(e) => setValue(e.target.value)}
                            value={value}
                        >
                            <Space direction="vertical" style={{ width: '100%', textAlign: 'center' }}>
                                {data.map((loc) => (
                                    <Radio disabled={loc.disabled} key={loc.id} value={loc.id}
                                        style={{ padding: '12px 8px', borderRadius: 8 }}>
                                        <span style={{ fontSize: 18 }}>{loc.nameAr || loc.name}</span>
                                    </Radio>
                                ))}
                                <Radio disabled
                                    style={{ padding: '12px 8px', borderRadius: 8 }}>
                                    <span style={{ fontSize: 18 }}>سيلة الظهر، جبع، عنزا، عجّة - قريباً جدًّا</span>
                                </Radio>
                            </Space>
                        </Radio.Group>
                    )}

                    <Button type="primary" size="large" onClick={handleSave} block
                        disabled={!value || isLoading || isError}>
                        متابعة
                    </Button>
                </Space>
            </Card>
        </div>
    )
}
